import { render } from "./QC1.vue?vue&type=template&id=c194d7f8"
import script from "./QC1.vue?vue&type=script&lang=js"
export * from "./QC1.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/QCCharts/microgen/QC1.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c194d7f8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c194d7f8', __exports__)) {
    console.log('reload')
    api.reload('c194d7f8', __exports__)
  }
  
  module.hot.accept("./QC1.vue?vue&type=template&id=c194d7f8", () => {
    console.log('re-render')
    api.rerender('c194d7f8', render)
  })

}


export default __exports__